import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton", "changesTextarea", "rejectionReason"]

  connect() {
    this.changeHandler = this.updateSubmitState.bind(this)
    this.element.addEventListener("change", this.changeHandler)
    this.updateSubmitState()
  }

  disconnect() {
    if (this.changeHandler) {
      this.element.removeEventListener("change", this.changeHandler)
    }
  }

  updateSubmitState() {
    const selectedOption = this.selectedOptionValue()
    const isRejected = selectedOption === "rejected"

    this.updateSubmitButtonText(isRejected)
    this.toggleChangesTextarea(isRejected)
  }

  handleSubmit(event) {
    const formData = new FormData(event.target)
    const selectedOption = formData.get("bdm_certificate[status]")

    if (selectedOption === "rejected" && this.hasRejectionReasonTarget && this.rejectionReasonTarget.value.trim() === "") {
      return
    }

    if (selectedOption === "accepted") {
      this.showModal("#modal-bdm_review_accept")
    } else if (selectedOption === "rejected") {
      this.showModal("#modal-bdm_review_reject")
    }
  }

  showModal(modalSelector) {
    const modal = document.querySelector(modalSelector)

    if (modal) {
      window.HSOverlay.open(modalSelector)
      this.modalOpen = true
    }
  }

  selectedOptionValue() {
    const checkedOption = this.element.querySelector("input[name='bdm_certificate[status]']:checked")
    return checkedOption?.value
  }

  updateSubmitButtonText(isRejected) {
    if (!this.hasSubmitButtonTarget) return

    const buttonText = this.submitButtonTarget.querySelector("[name='button-text']")
    if (!buttonText) return

    buttonText.textContent = isRejected ? "Submit Feedback" : "Approve Draft"
  }

  toggleChangesTextarea(isRejected) {
    if (this.hasChangesTextareaTarget) {
      this.changesTextareaTarget.classList.toggle("hidden", !isRejected)
    }

    if (this.hasRejectionReasonTarget) {
      this.rejectionReasonTarget.required = isRejected
    }
  }
}
